import { useStanQuery } from '@/queries';
import { fetchCustomerDetails } from '@/lib/api/audience/api';
import { QUERY_KEYS, SENTRY_FEATURES } from '@/lib/constants';
import type { CustomerProfile } from '../types/customer';

export interface UseCustomerDetailsResult {
    customer: CustomerProfile | null;
    isLoading: boolean;
    error: Error | null;
    refetch: () => void;
}

export function useCustomerDetails(userFanId: number): UseCustomerDetailsResult {
    const customerQuery = useStanQuery({
        queryKey: [QUERY_KEYS.CUSTOMER_DETAILS, userFanId],
        queryFn: async () => {
            return fetchCustomerDetails(userFanId);
        },
        enabled: !!userFanId,
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 2,
        meta: {
            error: { sentryMessage: '[AUDIENCE] failed-to-fetch-customer-details', feature: SENTRY_FEATURES.AUDIENCE },
        },
    });

    return {
        customer: customerQuery.data || null,
        isLoading: customerQuery.isLoading,
        error: customerQuery.error,
        refetch: customerQuery.refetch,
    };
}
